export default __webpack_public_path__ + "static/media/mexico-flag.5382ee77.png";